import flatpickr from "flatpickr";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import { initializeEpisodeSchedulePickers } from "./episodes/episode_schedule_picker";

require("flatpickr/dist/flatpickr.min.css")
require("flatpickr/dist/plugins/monthSelect/style.css")
window.monthSelectPlugin = monthSelectPlugin
let today = new Date();
let one_minute_from_now = new Date(today.getTime() + 60 * 1000); //2 = 2 hours previously it was 2 * 60 * 60 * 1000 but removed 2 because of client reason
document.addEventListener("turbo:load", () => {
    initializeEpisodeSchedulePickers(document, {
        flatpickr,
        pickerOptions: { weekNumbers: true },
    });
    flatpickr("[data-behavior='flatpickr']:not([data-episode-schedule-picker])", {
        enableTime: true,
        dateFormat: "Y-m-d H:i",
        minDate: one_minute_from_now,
        weekNumbers: true
    })
})
